
export function isEmptyText(htmlJson) {
    return htmlJson ? htmlJson.length === 1 && htmlJson[0].children[0]?.text?.length < 1 : true;
}